import React from 'react';
import Button from 'react-bootstrap/Button';
import '../View.css';

import AVSWhitelistCustomer from './AVSWhitelistCustomer';
import AVSWhitelistLookp from './AVSWhitelistLookup';

const LOOKUP = 'lookup';
const ADD = 'add';

class AVSWHitelist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: '',
    };
    this.handleBack = this.handleBack.bind(this);
  }

  handleSubmit = (event) => {
    this.setState({
      view: event.target.id,
    });
  };

  handleBack = () => {
    this.setState({
      view: '',
    });
  };

  renderPicker = () => {
    return (
      <div className="content mt-2" style={{ marginTop: '50px', }}>
        <p>
          <span className="lead">ACH Verification</span>
          <br />
          The ACH Account Verification whitelist only affects customers who are using apps that have Account Verification Service enabled.
        </p>
        <div>
          <Button variant="link" onClick={this.handleSubmit} id={ADD}>
            Add Customer To Whitelist
          </Button>
        </div>
        <div>
          <Button variant="link" onClick={this.handleSubmit} id={LOOKUP}>
            Lookup Customer in Whitelist
          </Button>
        </div>
      </div>
    );
  };

  render() {
    const { view, } = this.state;
    switch (view) {
      case ADD:
        return (<AVSWhitelistCustomer onBack={this.handleBack} />);
      case LOOKUP:
        return (<AVSWhitelistLookp onBack={this.handleBack} />);
      default:
        return this.renderPicker();
    }
  }
}

export default AVSWHitelist;
